import Tooltip from '@jetbrains/ring-ui/components/tooltip/tooltip'
import React, {memo} from 'react'

import type {PipelineButtonLinkProps} from '../ButtonLink/ButtonLink'
import ButtonLink from '../ButtonLink/ButtonLink'

import usePipelineEditButton from './usePipelineEditButton'

type PipelineEditButtonProps = PipelineButtonLinkProps

function PipelineEditButton(props: PipelineEditButtonProps) {
  const label = 'Edit'
  const {popupProps, hasEditPermission, permissionDenyMessage} = usePipelineEditButton()

  return (
    <Tooltip popupProps={popupProps} title={permissionDenyMessage}>
      <ButtonLink aria-label={label} disabled={!hasEditPermission} {...props}>
        {label}
      </ButtonLink>
    </Tooltip>
  )
}

export default memo<PipelineButtonLinkProps>(PipelineEditButton)
